import { LeadFormRequest, RequestDemoResponse } from '@upright/common/activities/contact-forms/request-demo/types';
import { getGoogleAnalyticsCookieValue } from '@upright/ui/common/generic/utilities/get-google-analytics-cookie-value';
import { useMutation } from '@tanstack/react-query';
import { ErrorWithHttpStatus } from '../common/error-with-http-status';
import { fetchOrThrow } from '../common/fetchers/fetch-or-throw';
import { getHubspotUtkCookie } from '@upright/ui/common/generic/utilities/get-hubspot-tracking-cookie';

export function useSubmitRequestDemoForm(onSuccess: () => void) {
  return useMutation<RequestDemoResponse, ErrorWithHttpStatus, LeadFormRequest>({
    mutationKey: ['submitRequestDemoForm'],
    mutationFn: async (request: LeadFormRequest) => {
      const requestWithCookies = {
        ...request,
        gaClientId: getGoogleAnalyticsCookieValue(),
        hubspotutk: getHubspotUtkCookie(),
      };
      return await submitRequestDemoForm(requestWithCookies);
    },
    onSuccess,
    onError: (error, variables) => {
      console.error('Request demo form submission failed', error, variables);
    },
  });
}

async function submitRequestDemoForm(request: LeadFormRequest): Promise<RequestDemoResponse> {
  const href = window.location.origin + window.location.pathname;
  const title = document.title;
  const req: LeadFormRequest = {
    ...request,
    context: { pageUri: href, pageName: title },
  };
  return await fetchOrThrow<RequestDemoResponse>('/request-demo', 'POST', req);
}
